import { SupportedLanguage } from '../api';

export interface TranslatedCountry {
  code: string;
  name: string;
}

export function getCountriesInLanguage(language: SupportedLanguage, countryCodes: string[]): TranslatedCountry[] {
  const displayNames = new Intl.DisplayNames([language], { type: 'region' });
  return countryCodes
    .map((code) => ({
      code,
      name: displayNames.of(code) ?? code,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function getCountryName(language: SupportedLanguage, countryCode: string): string {
  return new Intl.DisplayNames([language], { type: 'region' }).of(countryCode) ?? countryCode;
}
